import { useEffect } from "react";
import redClockImg from "../../assets/short_recording.svg";
import keyboardBackBtn from "../../assets/keyboard_back_btn.svg";
import useTranslationSetup from "../../utils/useTranslationSetup";
import "./styles.css";
import useParamValues from "../../utils/useParamValues";
import { getUserProperties } from "../../utils/helper";
import { produceEventLog } from "../../utils/helper";

const AssessmentNotConductedScreen = ({ handleShowStudentList }) => {
  const { t } = useTranslationSetup();
  const userProperties = getUserProperties(useParamValues());
  useEffect(() => {
    produceEventLog("assessment_3_no_result_available_page", {
      ...userProperties,
    });
  }, []);
  return (
    <div className="assessment-not-conducted-container">
      <div>
        <img
          src={redClockImg}
          alt="Missing Assessment"
          className="center-image"
        />
        <div className="assessment-not-conducted-heading">
          {t("student_assessment_not_done")}
        </div>
        <div className="assessment-not-conducted-description">
          {t("student_is_not_assessed")}
        </div>
      </div>
      {/* <div
        className="assessment-not-conducted-back-btn"
        onClick={handleShowStudentList}
      >
        <img src={keyboardBackBtn} alt="back button" />
        {t("student_list")}
      </div> */}
    </div>
  );
};

export default AssessmentNotConductedScreen;
